import type { FormikValues } from 'formik';

export const persistedFormValue = <Value extends FormikValues>(formName: string, fallback?: Value) => {
  const persistedValue = window.localStorage.getItem(formName);

  return {
    hasPersistedValue: !!persistedValue,
    initialValue: persistedValue ? (JSON.parse(persistedValue) as Value) : fallback ?? ({} as Value),
    persistValue: (value: Value) => window.localStorage.setItem(formName, JSON.stringify(value)),
    clearPersistedValue: () => window.localStorage.removeItem(formName),
  };
};

const listFormatter = new Intl.ListFormat('en', { style: 'long', type: 'conjunction' });
export const oxfordCommaFormatter = (list: string[]) => {
  return listFormatter.format(list);
};
